import { createHashRouter } from "react-router-dom";
import RootLayout from "./components/RootLayout";
import { sectionLayoutRoute } from "./routes";

// The app's PRIMARY router. The route tree itself lives in `routes.tsx` so the
// split view's right-hand pane can mount the same pages under its own memory
// router; this module only decides how the primary pane is hosted (hash
// history + the RootLayout shell).

// Bare-hash compatibility. Some surfaces navigate by setting a BARE slug on the
// hash (the Iron Dome overview tiles do `window.location.hash = "iron-dome-options"`
// from a backend-supplied value; old bookmarks are `#fx-hedging`). createHashRouter
// expects the `#/…` form, so rewrite any bare hash to leading-slash form. The
// rewrite is synchronous (only the hashchange *event* is async), so:
//   • at boot it runs before createHashRouter reads the initial location below;
//   • on a tile click, because this listener is registered BEFORE the router's
//     own (this module evaluates, and createHashRouter().initialize() subscribes,
//     only after these lines), it mutates location.hash before the router reads
//     it in the same event — the router then matches the normalized path.
if (typeof window !== "undefined") {
  const normalizeHash = () => {
    const h = window.location.hash;
    if (h.length > 1 && h[1] !== "/") {
      window.location.hash = "/" + h.slice(1);
    }
  };
  normalizeHash();
  window.addEventListener("hashchange", normalizeHash);
}

export const router = createHashRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [sectionLayoutRoute],
  },
]);
